import React from 'react';
import {useFetchFeedbacksShort} from "../../../hooks/useQuery/useFetchFeedbackShort";
import {PageHeader} from "../../../components/shared/PageHeader/PageHeader";
import {LoadingErrorBlock} from "../../../components/shared/LoadingErrorBlock";
import styles from "./FeedbackPage.module.css";
import {Link, useLocation} from "react-router-dom";

interface FeedbackPageProps {
    props?: string;
}

export const FeedbackAdminPage: React.FC<FeedbackPageProps> = ({props}) => {
    const location = useLocation();
    const {fbsShortData, fbsShortError, fbsShortIsLoading} = useFetchFeedbacksShort()
    return (
        <>
            <PageHeader
                title={"Обратная связь"}
                isAdmin={true}
                enabledBackBtn={false}
                enabledBreadcrumbs={false}
                buttons={
                    <></>
                }
            />
            <LoadingErrorBlock
                isLoading={fbsShortIsLoading}
                isError={Boolean(fbsShortError)}
                errorMessage="Ошибка загрузки обратной связи. Пожалуйста, попробуйте позже."
            />
            {fbsShortData && fbsShortData.length === 0 && !fbsShortError && !fbsShortIsLoading ? (
                <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    Обращений пока нет
                </div>
            ) :
                (
                <div className={styles.tableWrapper}>
                    <div className={`${styles.table} ${styles.tableOP}`}>
                        <div className={styles.tableBody}>
                            <div className={styles.rowHead}>
                                <div className={styles.col}>Дата и время</div>
                                <div className={styles.col}>Пользователь</div>
                                <div className={styles.col}>Тема</div>
                                <div className={styles.col}></div>
                            </div>
                            {fbsShortData && fbsShortData.map(fbs => (
                                <div key={fbs._id} className={styles.row}>
                                    <div className={styles.col}>
                                        {fbs.formattedDate}
                                    </div>
                                    <div className={styles.col}>
                                        {fbs.ownerInfo?.full_name}
                                    </div>
                                    <div className={styles.col}>
                                        {fbs.about}
                                    </div>

                                    <Link to={`${location.pathname}/${fbs._id}`} className={styles.col}>
                                        Перейти
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                )}

        </>
    )
};